<template>
  <div>
    <v-chart v-if="bare" class="chart" ref="chartRef" :option="chartOption" @click="handleChartClick" />
    <v-card v-else class="mb-4" style="height: 460px;">
      <v-card-title v-if="exportFilename" class="d-flex justify-space-between align-center">
        <span class="text-truncate">{{ title }}</span>
        <v-btn
          class="rdrive-chart-export flex-shrink-0"
          icon="mdi-download"
          variant="text"
          size="small"
          density="comfortable"
          :disabled="!hasData"
          @click="downloadPng"
        />
      </v-card-title>
      <v-card-title v-else>{{ title }}</v-card-title>
      <v-card-text>
        <v-chart class="chart" ref="chartRef" :option="chartOption" @click="handleChartClick" />
      </v-card-text>
    </v-card>
  </div>
</template>

<script src="./model.js"></script>
<style src="./style.css" scoped></style>
